import React from "react"

const InputUpperLabel = ({ children }) => (
    <span className="block text-sm font-medium leading-6 text-gray-900">
        {children}
    </span>
)

export default InputUpperLabel;